import { Link } from '@tanstack/react-router'

import { LogoWithText } from '@/components/icons/bitlyft-logo'
import { Button } from '@/components/ui/button'

export const NotFoundContent = () => {
	return (
		<main className="flex h-screen w-full flex-col items-center justify-center">
			<LogoWithText className="my-8 w-48" />
			<p className="text-lg font-medium">
				We couldn't find the page you were looking for.
			</p>
			<Button
				variant="outline"
				nativeButton={false}
				render={<Link to="/home" />}
				className="my-4"
			>
				Go home
			</Button>
		</main>
	)
}
